import validate from "/usr/src/app/content/n3-spas-587b5f58-aae4-4b83-99ed-2ef23b62989b/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-587b5f58-aae4-4b83-99ed-2ef23b62989b/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}